export enum EUserGroupRoles {
  User,
  Admin
}

